export default __webpack_public_path__ + "static/media/codegpt.79d8c78a.png";